export default {
  /**
   *
   * @param Vue
   * @param options
   */
  install(Vue, options) {
    /**
     *
     * @param content
     * @param trigger
     * @param placement
     * @returns {{targetClasses: [string], delay: {hide: number, show: number}, offset: number, classes: [string], placement: string, trigger: string, content}}
     */
    Vue.prototype.$tooltipConfig = function (content, trigger = 'hover', placement = 'left') {
      return {
        content,
        placement,
        trigger,
        classes: ['info'],
        targetClasses: ['it-has-a-tooltip'],
        offset: 10,
        delay: {
          show: 50,
          hide: 100,
        },
      }
    }

  }
}
